<template>
  <div>
    <div v-if="retData.length > 0" class="po">
      <el-dialog v-dialogDrag :close-on-click-modal="false" :modal="false" :show-close="false"
        :modal-append-to-body="true" custom-class="systemMessageDialog" :visible.sync="isDialogVisible"
        v-if="isDialogVisible" :before-close="beforeCloseHandle" width="330px" top="57vh" class="dialogDrag">
        <template v-slot:title>
          <span>你有[<span class="font-red">{{ retData.length }}条</span>]待处理消息,请及时处理</span>
        </template>
        <!-- 缩小按钮 -->
        <span class="smil" @click="smilDialog">
          <span>_</span>
        </span>
        <ul class="list-group list-group-LeftRight">
          <li class="list-group-item" v-for="item in retData" :key="item.id">
            <span>{{ item.desp }}</span>
            <p class="get_btn" @click="getDialog(item)">
              <i class="el-icon-view"></i>&nbsp;查看详情
            </p>
          </li>
        </ul>
      </el-dialog>
      <el-dialog v-dialogDrag :close-on-click-modal="false" :modal="false" :show-close="false"
        :modal-append-to-body="true" :visible.sync="isDialogVisibleM" v-if="isDialogVisibleM" width="170px" top="57vh"
        class="mdialogDrag">
        <template v-slot:title>
          <span>你有[<span class="font-red">{{ retData.length }}条</span>]...</span>
        </template>
        <!-- 放大按钮 -->
        <span class="old" @click="oldDialog">
          <i class="el-icon-full-screen"></i>
        </span>
      </el-dialog>
      <!-- 查看详情 -->
      <el-dialog title="消息详情:请仔细阅读" :close-on-click-modal="false" :append-to-body="true" :modal-append-to-body="true"
        :visible.sync="isDialogVisibleGet" v-if="isDialogVisibleGet" width="360px" class="mdialogGet">
        <span>{{ messageDetails.desp }}</span>
        <p class="mget_btn">
          <template v-if="messageDetails.toLinkUrl">
            <span class="mget_btn_a" @click="upReadMsg(messageDetails.id, messageDetails.toLinkUrl)">{{
              messageDetails.toLinkName }}</span>
          </template>
          <template v-else>
            <span @click="upReadMsg(messageDetails.id)">
              <i class="el-icon-check"></i> 我知道了</span>
            <span class="mget_btn_span" @click="isDialogVisibleGet = false"><i class="el-icon-view"></i> 继续提醒</span>
          </template>
        </p>
      </el-dialog>
    </div>
    <!-- 待接入学员等通知列表 -->
    <el-dialog title="待接入学员通知" :visible.sync="connectedDialogVisible" width="800px" :before-close="handleClose"
      :close-on-click-modal="false" class="notice_dialog">
      <div slot="title">
        <span class="notice_title" v-if="isBusiness">待接入学员通知</span>
        <span class="notice_title" v-else-if="isEdu">新生交接通知</span>
        <span class="notice_title" v-else>分配学员通知</span>
      </div>
      <el-table :data="tableData" stripe border class="notice_table" max-height="300px" :key="tableKey"
        :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column label="序号" width="60" type="index" :index="indexMethod" align="center">
        </el-table-column>
        <el-table-column prop="msg" label="通知内容">
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" v-if="isBusiness">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleScope(scope.row.studentId)">
              立即接入
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 单个待接入等通知 -->
    <el-dialog title="待接入学员通知" :visible.sync="centerDialogVisible" width="800px" center :data="tableData"
      class="notice_dialog" v-if="tableData && tableData.length > 0" :close-on-click-modal="false"
      :before-close="handleClose">
      <div slot="title">
        <span class="notice_title" v-if="isBusiness">待接入学员通知</span>
        <span class="notice_title" v-else-if="isEdu">新生交接通知</span>
        <span class="notice_title" v-else>分配学员通知</span>
      </div>
      <span v-if="tableData[0].msg">{{ tableData[0].msg }}</span>
      <span v-else>暂无消息通知~</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="handleScope(tableData[0].studentId)" v-if="isBusiness">立即接入</el-button>
        <el-button type="primary" @click="upReadMsg('', tableData[0].linkUrl)" v-else>点击查看</el-button>
      </span>
    </el-dialog>
    <!-- 是否关闭通知确认框 -->
    <el-dialog :visible.sync="closeVisible" title="提示" width="30%" align-center :before-close="handleCloseEnd"
      :close-on-click-modal="false" class="notice_dialog">
      <span class="close_tip">关闭后是否继续提醒该<span v-if="isBusiness">[待接入消息]!</span><span v-else-if="isEdu">[分配消息]!</span><span
          v-else>[分配交接消息]!</span>
        继续提醒将在系统右下角的消息盒子中与系统消息列表页中继续提醒,请选择！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upReadMsgList(tableData)">不再提醒</el-button>
        <el-button type="primary" @click="closeVisible = false">继续提醒</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as signalR from "@aspnet/signalr";
import { NotReadMsg, ReadMsg, ReadMsgList } from "network/systemMessage.js";
import { signalRDomain } from "../common/const.js";
import { SetToAccessStudentState } from "network/studentsBusiness";
export default {
  name: "SystemMessageDialog",
  data() {
    return {
      isDialogVisible: true,
      isDialogVisibleM: false,
      isDialogVisibleGet: false,
      retData: [],
      dialogTitleGet: "",
      messageDetails: "",
      dialogTitleM: "",
      connectedDialogVisible: false,  //是否显示待加入通知弹窗
      tableData: [], //待接入通知列表
      tableKey: true, //待通知列表Key
      centerDialogVisible: false, //是否显示单个待接入
      signalRSiteDomain: "", //signalR地址
      isBusiness: true,//是否是业务老师
      isEdu: false,  //是否是教务老师
      closeVisible: false,
      idList: [], //消息id列表
      stateData:[]
    };
  },
  computed: {
    listenMessage() {
      return this.$store.state.listenMessage;
    },
    // 获取管理员身份
    AdminCache() {
      return (
        this.$store.state.AdminCache || sessionStorage.getItem("AdminCache")
      );
    },
    allConfig() {
      return (
        sessionStorage.getItem('allConfig') ? JSON.parse(sessionStorage.getItem('allConfig')) : {}
      );
    }
  },
  watch: {
    listenMessage(newVal, oldVal) {
      this.goSignalR();
    },
    tableData: {
      handler(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          if (newValue.length == 1) {
            this.centerDialogVisible = true
          } else {
            this.connectedDialogVisible = true
          }
          this.tableKey = !this.tableKey
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.goSignalR();
  },
  // mounted() {
  //   this.getMsgData();
  // },
  methods: {
    // async getMsgData() {
    //   const result = await NotReadMsg(100);
    //   if (result && result.code == 1) {
    //     this.retData = result.result.memorandums;
    //   } else {
    //     this.retData = [];
    //   }
    // },
    // 点击关闭按钮
    beforeCloseHandle(done) {
      //   this.isShowWorkStateBar = true;
      done(); // 关闭dialog
    },
    getDialog(row) {
      this.isDialogVisibleGet = true;
      this.messageDetails = row;
    },
    // 关闭待接入通知
    handleClose(done) {
      this.closeVisible = true
      done();
    },
    handleCloseEnd(done) {
      done();
    },
    // 接入学员列表序号
    indexMethod(index) {
      return index + 1
    },
    // 接入学员
    async handleScope(studentId) {
      const result = await SetToAccessStudentState(studentId);
      if (result === 0) {
        this.$alert(result.message);
      } else {
        this.centerDialogVisible = false
        this.$alert(result.message);
        this.goSignalR();
      }
    },
    //关闭signalR连接
    closeSignalRConnection() {
      if (this.connection) {
        // 停止SignalR连接
        this.connection.stop().then(() => {
          console.log("SignalR连接已关闭");
        }).catch((err) => {
          console.error("关闭SignalR连接时出错:", err);
        });
      }
    },
    changeWorkState(){
      if(this.stateData[0]?.msg.indexOf('休息中') !== -1){
        this.$emit('changeWorkState', 3)
      }else if(this.stateData[0]?.msg.indexOf('工作中') !== -1){
        this.$emit('changeWorkState', 1)
      }else if(this.stateData[0]?.msg.indexOf('暂停中') !== -1){
        this.$emit('changeWorkState', 2)
      }
    },
    goSignalR() {
      let thisVue = this;
      let adminId = this.AdminCache.adminId || 1;
      thisVue.signalRSiteDomain = this.allConfig.signalRUrl || signalRDomain
      //1 客户端创建连接
      let connection = new signalR.HubConnectionBuilder()
        .withUrl(thisVue.signalRSiteDomain + "/chathub")
        .build();
        this.connection = connection
      //2 监听服务器端发送的方法
      connection.on("pushList" + adminId, function (obj) {
        thisVue.retData = obj;
        // thisVue.changeWorkState(obj)
      });
      connection.on("receiveupdate" + adminId, function (obj) {
        thisVue.retData = obj;
        // thisVue.changeWorkState(obj)
      });
      connection.on("finsied", function () {
        connection.stop();
        thisVue.retData = "finished";
      });
      // 业务消息
      connection.on("PushToAccessMsg" + adminId, function (model) {
        thisVue.tableData = model
        // thisVue.changeWorkState(obj)
      });
      // 教务消息
      connection.on("PushToHandoverMsg" + adminId, function (model) {
        thisVue.isBusiness = false
        thisVue.isEdu = true
        thisVue.tableData = model
        // thisVue.changeWorkState(obj)
      });
      // 用户运营消息
      connection.on("PushToOperationMsg" + adminId, function (model) {
        // thisVue.changeWorkState(obj)
        thisVue.isBusiness = false
        thisVue.isEdu = false
        thisVue.tableData = model
      });
      // 管理员状态消息
      connection.on("SetWorkRestMsg" + adminId, function (model) {
        thisVue.stateData = model
        thisVue.changeWorkState()
      });
      //3 开始通信，并调用服务器端方法GetLatestCount
      connection
        .start()
        .then(() => {
          connection.invoke("sendMsgToClient", adminId);
          // if(thisVue.isBusiness){
          //   connection.invoke("SendToAccessMsg", adminId);
          // } 
          //所有待接入，非实时
        })
        .catch((err) => console.error(err.toString()));
    },
    async upReadMsg(id, url) {
      if (id && id != "") {
        const result = await ReadMsg(id);
        if (
          result &&
          !result.code &&
          (result.code == 0 || result.code == undefined)
        ) {
          this.$alert(result.message);
          // return false;
        }
        if (result.code == 1) {
          // this.$alert(result.message);
        }
        this.isDialogVisibleGet = false;
        this.goSignalR();
      }
      if (url) {
        this.centerDialogVisible = false;
        this.toLInkUrl(url);
      }
    },
    // 不再提醒
    async upReadMsgList(list) {
      if (list && list.length > 0) {
        this.idList = list.map(item => {
          return (item.id)
        })
      }
      const listRes = await ReadMsgList(this.idList);
      if (listRes.code != 1) {
        this.$alert(listRes.message);
      }
      this.closeVisible = false
    },
    // 跳转到指定菜单
    toLInkUrl(url) {
      let tabObj = {
        component: "",
        name: "",
        title: "",
        index:"",
      };
      var isNumber = Number(url);
      let theMenuChilds = JSON.parse(sessionStorage.getItem("theMenuChilds")) || "";
      if (theMenuChilds != "") {
        theMenuChilds.map((item1) => {
          if (item1.childs.length > 0) {
            item1.childs.map((item2) => {
              if (item2.id == isNumber) {
                //二级菜单
                tabObj.component = item2.componentName;
                tabObj.name = item2.id
                tabObj.index = item2.id
                // item1.orders.toString() + "-" + item2.orders.toString();
                tabObj.title = item2.name;
              }
              if (item2.childs.length > 0) {
                item2.childs.map((item3) => {
                  //三级菜单
                  if (item3.id == isNumber) {
                    tabObj.component = item3.componentName;
                    tabObj.name = item3.id;
                    tabObj.index = item3.id;
                    // item1.orders.toString() +
                    // "-" +
                    // item2.orders.toString() +
                    // "-" +
                    // item3.orders.toString();
                    tabObj.title = item3.name;
                  }
                });
              }
            });
          } else {
            // 只有一级菜单
            item1.childs.map((item1) => {
              if (item1.id == isNumber) {
                tabObj.component = item1.componentName;
                // tabObj.name = item1.orders.toString();
                tabObj.name = item1.id;
                tabObj.index = item1.id;
                tabObj.title = item1.name;
              }
            });
          }
        });
      }
      if (url.indexOf("http") > -1) {
        window.open(url, "_blank");
        return;
      }

      if (tabObj.name) {
        tabObj.name = tabObj.name.toString()
        tabObj.index = tabObj.index.toString()
        this.$emit("add-tab", tabObj);
        sessionStorage.setItem("tabObj", JSON.stringify(tabObj)); //存储AdminCache
      } else {
        this.$message.error("当前角色没有权限");
      }
    },
    smilDialog() {
      this.isDialogVisible = false;
      this.isDialogVisibleM = true;
    },
    oldDialog() {
      this.isDialogVisible = true;
      this.isDialogVisibleM = false;
    },
  },
};
</script>

<style scoped>
.el-dialog__wrapper {
  /* position: fixed;
    top: inherit;
    left: inherit;
    right: 0;
    bottom: 0;
    width: 330px;
  height: 360px; */
  pointer-events: none;
}

.dialogDrag>>>.el-dialog {
  position: absolute;
  height: 394px;
  top: 0;
  right: 0;
  bottom: 0 !important;
  pointer-events: auto;
}

.mdialogDrag>>>.el-dialog {
  height: 44px;
  position: absolute;
  right: 0;
  bottom: 0 !important;
  pointer-events: auto;
}
.mdialogDrag ::v-deep .el-dialog__body{
  padding: 0;
}
.mdialogGet>>>.el-dialog {
  pointer-events: auto;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0 !important;
}

>>>.el-dialog__header {
  background: #fafafa;
  padding: 10px 20px 10px;
}

>>>.el-dialog__headerbtn {
  top: 10px;
}

.red {
  color: #ff5a47;
}

>>>.el-dialog__title {
  font-size: 14px;
}

.dialogDrag>>>.el-dialog__body {
  padding: 0;
  max-height: 360px;
  min-height: 350px;
  overflow-y: scroll;
}

.mdialogGet>>>.el-dialog__body {
  padding: 15px 20px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.list-group-item span {
  width: 100%;
  max-height: 60px;
  line-height: 30px;
  display: inline-block;
  overflow: hidden;
}

.get_btn {
  width: 100%;
  padding: 5px;
  border: 1px solid transparent;
  border-radius: 4px;
  border-color: #adadad;
  text-align: center;
  cursor: pointer;
}

.get_btn:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.smil {
  position: absolute;
  top: 3px;
  right: 8px;
  text-align: center;
  font-size: 25px;
  background: #fafafa;
  cursor: pointer;
  width: 30px;
  display: inline-block;
  height: 37px;
  line-height: 2px;
}

.old {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}

.mget_btn {
  margin-top: 20px;
  text-align: right;
}

.mget_btn span {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 4px;
  color: #fff;
  background-color: #337ab7;
  border: 1px solid #2e6da4;
  cursor: pointer;
}

.mget_btn .mget_btn_span {
  margin-left: 10px;
  color: #333;
  background-color: #fff;
  border: 1px solid #ccc;
}

.mget_btn_a {
  padding: 6px 12px;
  color: #fff;
  background-color: #337ab7;
  border: 1px solid #2e6da4;
  border-radius: 4px;
}

.el-icon-check {
  position: inherit;
}

.font-red {
  color: #f5210a;
}

/* 待接入通知 */
.notice_title {
  font-weight: 700;
  font-size: 18px;
}

.notice_table {
  /* max-height: 600px; */
}

.notice_table::-webkit-scrollbar {
  display: none
}

.notice_table>>>.el-table thead {
  background-color: #FAFAFA;
  color: #909399;
  font-weight: 500;
}

.notice_dialog>>>.el-dialog {
  pointer-events: auto;
}
</style>